import * as React from 'react';

import { useIsSearchSucceedSelector } from '@/microfrontends/filters/shared/store/slices/listing/selectors';

const DISABLE_BY_SCROLL_TIMEOUT = 200;

// TODO Переделать для новых фильтров
export function useTooltipDisabled(): boolean {
  const isTooltipDisabledByState = useTooltipDisabledByState();
  const [isTooltipDisabledByScroll, setIsTooltipDisabledByScroll] = React.useState(false);

  React.useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleScroll = (): void => {
      setIsTooltipDisabledByScroll(true);
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        clearTimeout(timeoutId);
        setIsTooltipDisabledByScroll(false);
      }, DISABLE_BY_SCROLL_TIMEOUT);
    };

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isTooltipDisabledByState || isTooltipDisabledByScroll;
}

function useTooltipDisabledByState(): boolean {
  const isSearchOffersSucceed = useIsSearchSucceedSelector();

  // TODO прятать при получении офферов, при открытых модалках
  return isSearchOffersSucceed;
}
